exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid-cx[data-v-649f953a]{display:grid;grid-template-columns:repeat(4,25%)}@media screen and (max-width:428px){.grid-cx[data-v-649f953a]{grid-template-columns:1fr}}.border-b-cx[data-v-649f953a]{border-bottom:1px solid #f2f2f3}", ""]);

// exports
